const MAX_SESSION_TITLE_LENGTH = 64;

const LEADING_REQUEST_PHRASES = [
  /^please\s+/i,
  /^can\s+you\s+/i,
  /^could\s+you\s+/i,
  /^would\s+you\s+/i,
  /^i\s+need\s+you\s+to\s+/i,
  /^i\s+need\s+to\s+/i,
  /^help\s+me\s+/i,
  /^make\s+sure\s+to\s+/i,
];

function normalizeInitialRequest(input: string): string {
  return input
    .replace(/```[\s\S]*?```/g, " ")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/\[[^\]]+\]\(([^)]+)\)/g, " ")
    .replace(/https?:\/\/\S+/g, " ")
    .replace(/^\/[\w-]+\s+/i, "")
    .replace(/^[#>\s-]+/, "")
    .replace(/\s+/g, " ")
    .trim();
}

function trimAtThoughtBoundary(input: string): string {
  const boundary = input.search(/[.!?\n]|;\s+/);
  if (boundary > 12) return input.slice(0, boundary).trim();
  return input.trim();
}

function compactToLength(input: string, maxLength: number): string {
  if (input.length <= maxLength) return input;
  const clipped = input.slice(0, maxLength + 1);
  const lastSpace = clipped.lastIndexOf(" ");
  const safe = lastSpace > 24 ? clipped.slice(0, lastSpace) : clipped;
  return safe.replace(/[,\s]+$/, "").trim();
}

export function deriveConversationTitleFromInitialRequest(
  input: string,
  maxLength = MAX_SESSION_TITLE_LENGTH,
): string | null {
  let title = trimAtThoughtBoundary(normalizeInitialRequest(input));
  for (const phrase of LEADING_REQUEST_PHRASES) {
    title = title.replace(phrase, "");
  }

  title = compactToLength(title, maxLength);
  if (title.length < 3) return null;

  return title.charAt(0).toUpperCase() + title.slice(1);
}
